import { Component, OnInit } from '@angular/core';
import { LookupScreenService } from '../../../../../../services/lookup-screen.service';
import { Router } from '@angular/router';
import { DoctorBreadcrumbService } from '../../../../shared/breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';

export interface searchBody {
    current_user_guid: string;
    medical_record_number?: string;
    e_email?: string;
    mobile_number?: string;
    records_per_page: number;
    page_no: number;
}

@TraceClassDecorator()
@Component({
    selector: 'app-lookup-search-p',
    templateUrl: './lookup-search-p.component.html',
    styleUrls: [
        './lookup-search-p.component.css',
        '../../../../../../../assets/css/custom-egd.css'
    ]
})
export class LookupSearchPComponent implements OnInit {
    constructor(
        private lookupservice: LookupScreenService,
        private router: Router,
        private titleService: Title,
        private breadcrumbService: DoctorBreadcrumbService,
        private readonly providerstateService: ProviderStateService
    ) {

    }

    e: string = '';
    searchType: any;
    inptype: string;
    inpdata: string;
    slug: string = "";
    Type: any[] = [
        { name: 'EMAIL', value: 'e_email' },
        { name: 'MRN', value: 'medical_record_number' },
        { name: 'PHONE', value: 'mobile_number' }
    ];
    body: searchBody;
    loading = false;

    isValidData(type: string, data: string): boolean {
        switch (type) {
            case 'medical_record_number':
                if (
                    data.length >= 4 &&
                    data.length <= 6 &&
                    data.match(/^[0-9]+$/)
                ) {
                    this.body = {
                        current_user_guid: sessionStorage.getItem('userid'),
                        medical_record_number: data,
                        records_per_page: 100,
                        page_no: 1
                    };
                    this.searchType = "medical_record_number";
                    return true;
                } else {
                    this.e = 'Invalid Medical Record Number !';
                    return false;
                }
            case 'e_email':
                const re =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(data.toLowerCase())) {
                    this.body = {
                        current_user_guid: sessionStorage.getItem('userid'),
                        e_email: data,
                        records_per_page: 100,
                        page_no: 1
                    };
                    this.searchType = "e_email";
                    return true;
                } else {
                    this.e = 'Invalid  Email !';
                    return false;
                }
            case 'mobile_number':
                if (
                    data.length >= 4 &&
                    data.length <= 10 &&
                    data.match(/^[0-9]+$/)
                ) {
                    this.body = {
                        current_user_guid: sessionStorage.getItem('userid'),
                        mobile_number: data,
                        records_per_page: 100,
                        page_no: 1
                    };
                    this.searchType = "mobile_number";
                    return true;
                } else {
                    this.e = 'Invalid  Phone Number !';
                    return false;
                }
        }
    }

    getInput(inptype: string, inpdata: string) {
        if (this.isValidData(inptype, inpdata)) {
            this.loading = true;
            this.lookupservice
                .searchPersonalDetails(this.body)
                .then((resp) => {
                    if (resp.data.patient.count > 0) {
                        this.body.e_email
                        this.router.navigate(['/' + this.slug + '/doctor/lookup-list-p'], { queryParams: { searchType: inptype, searchData: inpdata } });
                    } else {
                        this.e = "No Record Found !!"
                    }
                })
                .catch((error) => (this.e = error.error.message));
        }
        this.loading = false;
    }

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Lookup Screen' },
            { label: 'Lookup Patients' }
        ]);
        this.titleService.setTitle('Dashboard - Lookup Patients');
    }
}
